
export const PLATFORM_MASTER = () => `
{
  platform_data {
    claimr_points
    platform_tvl {
      usd
      brkt
    }
    total_holdings {
      usd
      brkt
    }
    total_invested {
      usd
      brkt
    }
    total_current_value {
      usd
      brkt
    }
    brkt_1d {
      deposits {
        usd
        brkt
      }
      withdrawals {
        usd
        brkt
      }
    }
    brkt_3d {
      deposits {
        usd
        brkt
      }
      withdrawals {
        usd
        brkt
      }
    }
    brkt_7d {
      deposits {
        usd
        brkt
      }
      withdrawals {
        usd
        brkt
      }
    } 
    brkt_14d {
      deposits {
        usd
        brkt
      }
      withdrawals {
        usd
        brkt
      }
    } 
    brkt_21d {
      deposits {
        usd
        brkt
      }
      withdrawals {
        usd
        brkt    
      }
    }
    brkt_28d {
      deposits {
        usd
        brkt  
      }
      withdrawals {
        usd
        brkt
      }
    } 
  }
}`;
